import { render, staticRenderFns } from "./EntityRelation.vue?vue&type=template&id=29097b11"
import script from "./EntityRelation.vue?vue&type=script&lang=ts"
export * from "./EntityRelation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports